import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import './Header.scss';
import Logo from '../Logo/Logo';
import Nav from './Nav/Nav';

import Tribar from '../../Assets/tribar.svg'

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
    }
  }

  render() {
    const { menuOpen } = this.state;

    return (
      <header>
        <div className='header-container'>
          <Logo />
          <Nav menuOpen={menuOpen} />
          <img
            className='header-button no-select'
            src={Tribar}
            alt='menu'
            onClick={() => { this.setState({ menuOpen: !menuOpen }); }}
          />
        </div>
      </header>
    );
  }
}

Header.contextType = GraingerAccountContext;
export default Header;